import { downloadCohortContract } from 'actions/cohorts';
import CreateCohortModal from 'components/CohortsList/CreateCohortModal';
import {
  platformMap,
  scanMap,
} from 'components/CustomerImport/ImportReviewSelections/ImportReviewDetails';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Cohort } from 'types';

type ComponentProps = {
  cohort: Cohort;
};

const SOWDetails: React.FC<ComponentProps> = ({ cohort }) => {
  const dispatch = useDispatch();

  const {
    sync_start_date: startDate,
    sync_end_date: endDate,
    insight_seats: insightSeats,
    prevent_seats: preventSeats,
    platforms,
    scan_for: scanFor,
  } = cohort.config;

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const toggleEditModal = (): void => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const handleContractLinkClick = (): void => {
    dispatch(downloadCohortContract({ cohortId: cohort.uuid }));
  };

  return (
    <>
      <div className="w-166 h-58 p-6 flex flex-row gap-4 text-body bg-white border border-litlingo-gray-2 rounded">
        <div className="w-full flex flex-col gap-4">
          <span className="text-heading-3">SOW Details</span>
          <div className="w-full flex flex-col gap-4 text-body bg-white">
            <div className="flex flex-col gap-2">
              <p>
                <b>{insightSeats} Insight</b> seats & <b>{preventSeats} Prevent</b> seats
              </p>
              {startDate || endDate ? (
                <p>
                  {!endDate ? 'Livestream start date' : 'Lookback date range'}:{' '}
                  <b>{moment(startDate).format('MM/DD/yyyy')}</b>
                  {endDate && <b>–{moment(endDate).format('MM/DD/yyyy')}</b>}
                </p>
              ) : (
                <p>
                  Lookback date range: <b>Not set</b>
                </p>
              )}
              <p>
                Platform permissions needed:{' '}
                <b>
                  {platforms.map((p) => platformMap[p as keyof typeof platformMap]).join(',')
                    ? platforms.map((p) => platformMap[p as keyof typeof platformMap]).join(',')
                    : 'Not set'}
                </b>
              </p>
              <p>
                Scan attachments for{' '}
                <b>
                  {scanMap[scanFor as keyof typeof scanMap]
                    ? scanMap[scanFor as keyof typeof scanMap]
                    : 'Not set'}
                </b>
              </p>
            </div>
          </div>
        </div>
        <div className="h-full border-l border-litlingo-gray-2" />
        <div className="w-full h-full flex flex-row gap-6">
          <div className="w-full flex flex-col gap-4 justify-between">
            <div className="h-full w-full flex flex-col gap-2 overflow-hidden">
              <button
                type="button"
                className="self-end text-litlingo-primary underline focus:outline-none"
                onClick={toggleEditModal}
              >
                Edit Details
              </button>
              <div className="h-full flex flex-col gap-2 overflow-hidden">
                <span>Notes:</span>
                <span className="flex flex-1 overflow-auto custom-scrollbar">
                  {cohort.config.notes ? cohort.config.notes : 'No cohort notes.'}
                </span>
              </div>
            </div>

            {cohort.config.contract_filename && (
              <button
                type="button"
                className="self-end flex flex-row focus:outline-none"
                onClick={handleContractLinkClick}
              >
                <span className="max-w-32 truncate underline">
                  {cohort.config.contract_filename?.split('.')[0]}
                </span>
                <span className="underline">
                  .{cohort.config.contract_filename?.split('.').pop()}
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
      {isEditModalOpen && (
        <CreateCohortModal
          cohort={cohort}
          isModalOpen={isEditModalOpen}
          toggleModalOpen={toggleEditModal}
          isEditing
        />
      )}
    </>
  );
};

export default SOWDetails;
